import { Divider, Stack, Text, LegacyText } from "flicket-ui";
import { useEffect } from "react";
import { SignupEmbedFormInterface } from ".";

const DIVIDER_HEIGHT = 1;
const HEADER_MARGIN_Y = 24;
const CONTENT_MARGIN_Y = 32;

export const SignupEmbedSuccess = (props: SignupEmbedFormInterface) => {
  const { successHeading, successMessage, styles } = props;

  useEffect(() => {
    const heading = document.querySelector("#flicket-form-success-heading");
    const message = document.querySelector("#flicket-form-success-message");
    if (heading && message) {
      const headingHeight = heading.getBoundingClientRect().height;
      const messageHeight = message.getBoundingClientRect().height;
      const height =
        headingHeight +
        messageHeight +
        DIVIDER_HEIGHT +
        HEADER_MARGIN_Y * 2 +
        CONTENT_MARGIN_Y * 2;

      window.parent.postMessage(
        JSON.stringify({
          type: "resize",
          height,
        }),
        "*"
      );
    }
  }, []);

  return (
    <Stack
      id="flicket-form"
      direction={"vertical"}
      backgroundColor={styles.backgroundColour as any}
      className="flicket-form"
    >
      <Text
        variant="header.M"
        as="h2"
        id="flicket-form-success-heading"
        className="flicket-text"
        mx={4}
        my={3}
        color={styles.textColour as any}
      >
        {successHeading}
      </Text>
      <Divider className="flicket-divider" />
      <LegacyText
        color={styles.textColour as any}
        id="flicket-form-success-message"
        className="flicket-text"
        m={4}
      >
        {successMessage}
      </LegacyText>
    </Stack>
  );
};
